import React from 'react';
import { CaseData, EnterpriseData } from '../../entity/entity.types';
import {
  fetchEnterpriseCaseCount,
  fetchOppositeEnterprisesCaseCount,
} from '../enterprise.api';
import { chartValuesNotAllZero } from '../../entity/charts/chartsUtils';
import { EvolutionChartCard } from './evolution-chart/EvolutionChartCard';
import { withEnterprise } from './EnterpriseContext';
import { EnterpriseContextType } from './enterprise.types';

type Props = {
  displayTitle: Function;
} & EnterpriseContextType;

type State = {
  oppositesEnterpriseDatas: Array<EnterpriseData>;
  caseData: CaseData;
};

export class RawEnterpriseEvolution extends React.Component<Props, State> {
  state: State = {
    oppositesEnterpriseDatas: [],
    caseData: {
      years: [],
      caseCounts: [],
    },
  };

  async componentDidMount() {
    const {
      enterpriseInfos: { siren },
      displayTitle,
    } = this.props;
    const [
      oppositeEnterprisesCaseCountResponse,
      enterpriseCaseCountResponse,
    ] = await Promise.all([
      fetchOppositeEnterprisesCaseCount(siren),
      fetchEnterpriseCaseCount(siren),
    ]);

    const oppositesEnterpriseDatas = oppositeEnterprisesCaseCountResponse.data.oppositeEnterprisesCaseCount.slice(
      0,
      3,
    );
    const { caseData } = enterpriseCaseCountResponse.data;

    if (chartValuesNotAllZero(caseData.caseCounts)) {
      displayTitle();
      this.setState({
        oppositesEnterpriseDatas,
        caseData,
      });
    }
  }

  render() {
    const {
      experience: { decisionCount },
      enterpriseInfos: { raisonSociale, siren, enterpriseId },
    } = this.props;
    const { caseData, oppositesEnterpriseDatas } = this.state;

    if (caseData.caseCounts.length === 0) {
      return null;
    }

    const enterpriseDatas = {
      siren,
      raisonSociale,
      enterpriseId,
      chronology: {
        caseData,
      },
    };

    return (
      <EvolutionChartCard
        enterpriseDatas={enterpriseDatas}
        oppositesEnterpriseDatas={oppositesEnterpriseDatas}
        decisionCount={decisionCount}
      />
    );
  }
}

export const EnterpriseEvolution = withEnterprise(RawEnterpriseEvolution);
